const { $ } = window;

export default {
  methods: {
    closeModal() {
      $('#becomeAnExpertModal').closeModal();
    }
  },
  mounted() {
    $('.becomeanexpertmodal-trigger').leanModal();
  }
};
